/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './accounting-tax.reducer';

export const AccountingTaxDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const accountingTaxEntity = useAppSelector(state => state.accountingTax.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="accountingTaxDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.accountingTax.detail.title">AccountingTax</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.accountingTax.id">Id</Translate>
            </span>
          </dt>
          <dd>{accountingTaxEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.accountingTax.name">Name</Translate>
            </span>
            <UncontrolledTooltip target="name">
              <Translate contentKey="tinyMedicRestApp.accountingTax.help.name" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTaxEntity.name}</dd>
          <dt>
            <span id="rate">
              <Translate contentKey="tinyMedicRestApp.accountingTax.rate">Rate</Translate>
            </span>
            <UncontrolledTooltip target="rate">
              <Translate contentKey="tinyMedicRestApp.accountingTax.help.rate" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTaxEntity.rate}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.accountingTax.country">Country</Translate>
            </span>
            <UncontrolledTooltip target="country">
              <Translate contentKey="tinyMedicRestApp.accountingTax.help.country" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTaxEntity.country}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.accountingTax.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.accountingTax.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTaxEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingTax.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingTax.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTaxEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingTax.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingTax.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTaxEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingTax.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingTax.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTaxEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingTax.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingTax.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTaxEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTax.type">Type</Translate>
          </dt>
          <dd>{accountingTaxEntity.type ? accountingTaxEntity.type.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTax.transaction">Transaction</Translate>
          </dt>
          <dd>
            {accountingTaxEntity.transactions
              ? accountingTaxEntity.transactions.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {accountingTaxEntity.transactions && i === accountingTaxEntity.transactions.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTax.account">Account</Translate>
          </dt>
          <dd>
            {accountingTaxEntity.accounts
              ? accountingTaxEntity.accounts.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {accountingTaxEntity.accounts && i === accountingTaxEntity.accounts.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/accounting-tax" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/accounting-tax/${accountingTaxEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AccountingTaxDetail;
